/* =========================
   LMG CART DRAWER (INIT SAFE)
   ========================= */

/*

Hey Nipuna!

Just wanted to say again — I’ve really enjoyed working with you. You’ve been crushing it and the quality/speed has been awesome.

Quick question: would you be open to doing some work outside of Fiverr and getting paid through PayPal? Totally optional of course, no pressure at all. 

I just know Fiverr takes a pretty brutal cut, and I’d rather that money go to you instead of them.

I’ve done this with a couple other contractors I work with now and it’s been super smooth, so figured I’d ask.

And if you still want to keep Fiverr activity going for reviews/visibility, I’m happy to leave reviews anytime —
we could even run jobs through for a very small amount so you still get the public feedback, and then handle the majority of the payment outside.

Either way I’m definitely down to keep working together if you are.  

IF you ARE interested, feel free to email me at my work email david@liftgateme.com

Thanks again Nipuna!
David

*/



(function () {
  window.LMG = window.LMG || {};

  function initLMGDrawer() {
    const drawer = document.getElementById('lmg-drawer');
    if (!drawer) return false;
    if (drawer.dataset.lmgReady === '1') return true; // already initialized

    const overlayCloses = drawer.querySelectorAll('[data-lmg-close]');
    const itemsWrap = drawer.querySelector('.lmg-itemsWrap');
    const itemsEl = drawer.querySelector('#lmgItems');
    const scrollHint = drawer.querySelector('#lmgScrollHint');
    const subtotalMount = drawer.querySelector('#lmgSubtotalMount');
    const footer = drawer.querySelector('#lmgFooter');
    const bottomScroll = drawer.querySelector('.lmg-bottomScroll'); // accordions wrapper

    // -------------------------
    // Open / Close
    // -------------------------
    function openDrawer() {
      drawer.classList.add('lmg-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      loadCart();
    }

    function closeDrawer() {
      drawer.classList.remove('lmg-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    overlayCloses.forEach((el) => el.addEventListener('click', closeDrawer));

    // ESC to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('lmg-drawer--open')) {
        closeDrawer();
      }
    });

    // Click header icons ONLY (safe target)
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.lgm-cart, .lgm-mcart');
      if (!trigger) return;
      e.preventDefault();
      openDrawer();
    });

    // Optional: open drawer when your theme dispatches this
    document.addEventListener('product.added', openDrawer);


    function flashAddedToCart() {
      const titleWrap = document.getElementById('lmgHeaderTitle');
      const iconWrap  = document.getElementById('lmgHeaderIcon');
      const textEl    = document.getElementById('lmgHeaderText');
      if (!titleWrap || !iconWrap || !textEl) return;

      // Save original
      const originalIcon = iconWrap.innerHTML;
      const originalText = textEl.textContent;

      // Add styling class
      titleWrap.classList.add('is-added');

      // Replace with check icon + text
      iconWrap.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg"
            width="24" height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round">
          <path d="M5 13l4 4L19 7"/>
        </svg>
      `;
      textEl.textContent = 'Added to cart';

      // Revert after 2s
      setTimeout(() => {
        iconWrap.innerHTML = originalIcon;
        textEl.textContent = originalText;
        titleWrap.classList.remove('is-added');
      }, 2000);
    }


    function syncHeaderCartCount(cart) {
      const count = Number(cart?.item_count || 0);

      // desktop badge
      document.querySelectorAll('.lgm-cart__count').forEach(el => {
        el.textContent = String(count);
      });

      // mobile badge
      document.querySelectorAll('.lgm-mcart__count').forEach(el => {
        el.textContent = String(count);
      });

      // if you have any other count elements
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = String(count);
      });

      // optional: hide badge when 0
      document.querySelectorAll('.lgm-cart__count, .lgm-mcart__count').forEach(el => {
        el.style.display = count > 0 ? '' : 'none';
      });
    }

    // -------------------------
    // Helpers
    // -------------------------
    function money(cents) {
      try {
        return Shopify.formatMoney(cents, window.shop?.moneyFormat || '${{amount}}');
      } catch (e) {
        const v = (cents / 100).toFixed(2);
        return '$' + v;
      }
    }

    function safeImg(item) {
      if (item.image) return item.image;
      return 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    }

    /*
    function buildOrderNote() {
      const notes = (document.getElementById('lmgNotes')?.value || '').trim();

      const make  = (document.getElementById('lmgMake')?.value || '').trim();
      const model = (document.getElementById('lmgModel')?.value || '').trim();
      const serial= (document.getElementById('lmgSerial')?.value || '').trim();

      // If nothing is filled, just return the notes (or empty)
      const hasLiftgate = !!(make || model || serial);

      const LIFT_START = '--- LIFTGATE INFORMATION (LMG) ---';
      const LIFT_END   = '--- END LIFTGATE INFORMATION (LMG) ---';

      let liftgateBlock = '';
      if (hasLiftgate) {
        liftgateBlock = [
          LIFT_START,
          `Make: ${make || '-'}`,
          `Model: ${model || '-'}`,
          `Serial #: ${serial || '-'}`,
          LIFT_END
        ].join('\n');
      }

      // Remove any previous LMG liftgate block to avoid duplicates
      const stripOldLiftgate = (text) => {
        if (!text) return '';
        const re = new RegExp(`${LIFT_START}[\\s\\S]*?${LIFT_END}\\n?`, 'g');
        return text.replace(re, '').trim();
      };

      const base = stripOldLiftgate(notes);

      // Combine nicely
      if (liftgateBlock) {
        return base ? `${base}\n\n${liftgateBlock}` : liftgateBlock;
      }
      return base; // only general notes
    }

    async function saveOrderNoteToCart() {
      const note = buildOrderNote();

      // If you want to FORCE clearing notes when empty, keep as is.
      // If you want to avoid updating when empty, you can early return.
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ note })
      });
    }
    */

function getGeneralNotes() {
  return (document.getElementById('lmgNotes')?.value || '').trim();
}

function getLiftgateAttributes() {
  const make   = (document.getElementById('lmgMake')?.value || '').trim();
  const model  = (document.getElementById('lmgModel')?.value || '').trim();
  const serial = (document.getElementById('lmgSerial')?.value || '').trim();

  // Return empty strings if blank (Shopify will keep keys unless you explicitly clear)
  return {
    liftgate_make: make,
    liftgate_model: model,
    liftgate_serial: serial
  };
}

async function saveCartMeta() {
  const note = getGeneralNotes();
  const attributes = getLiftgateAttributes();

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      note,        // only general notes
      attributes   // structured liftgate fields
    })
  });
}


    function moveSubtotalMobileOnly() {
      const card = drawer.querySelector('.lmg-subtotalCard');
      if (!card) return;

      const isMobile = window.matchMedia('(max-width: 640px)').matches;

      // Ensure footer slot exists (only needed when mobile)
      let slot = drawer.querySelector('#lmgFooterSubtotal');

      if (isMobile) {
        if (!slot) {
          slot = document.createElement('div');
          slot.id = 'lmgFooterSubtotal';
          slot.className = 'lmg-footerSubtotal';
          footer.prepend(slot); // put subtotal above buttons
        }
        if (card.parentElement !== slot) slot.appendChild(card);
      } else {
        // Desktop: put subtotal back in the mount and remove the slot
        if (card.parentElement !== subtotalMount) subtotalMount.appendChild(card);
        if (slot) slot.remove();
      }
    }

    // -------------------------
    // Cart load + render
    // -------------------------
    async function loadCart() {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      syncHeaderCartCount(cart);
      renderCart(cart);
    }

    function renderCart(cart) {
      syncHeaderCartCount(cart);
      // Empty cart
      if (!cart || cart.item_count === 0) {
        itemsEl.innerHTML = `
          <section class="lmg-emptyPlus" aria-label="Empty cart">
            <div class="lmg-emptyPlus__hero" aria-hidden="true">
              <div class="lmg-emptyPlus__img">
                <img class="lmg-emptyPlus__imgReal" src="${window.LMG_EMPTY_IMG || ''}" alt="Empty cart">
              </div>
            </div>

            <div class="lmg-emptyPlus__content">
              <h3 class="lmg-emptyPlus__title">Your cart is empty</h3>
              <p class="lmg-emptyPlus__text">
                Search by part number, model, or diagram to add parts to your cart.
              </p>

              <div class="lmg-emptyPlus__card">
                <p class="lmg-emptyPlus__hint">Sign in to see items you may have added previously.</p>

                <a class="lmg-btn lmg-btn--primary" href="/account/login">Sign In</a>
                <a class="lmg-btn lmg-btn--outline" href="/account/register">Create Account</a>

                <div class="lmg-emptyPlus__scrollCueWrap">
                  <div class="lmg-emptyPlus__scrollCue" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lmg-emptyPlus__scrollIco">
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>
                    <span>Scroll for more</span>
                  </div>
                </div>

                <ul class="lmg-emptyPlus__benefits" role="list">
                  <li class="lmg-benefit">
                    <span class="lmg-benefit__ico" aria-hidden="true">
                      <svg class="w-full h-full text-[#212529]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                    </span>
                    <span class="lmg-benefit__txt">Track orders and view purchase history</span>
                  </li>

                  <li class="lmg-benefit">
                    <span class="lmg-benefit__ico" aria-hidden="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck w-full h-full text-[#212529]">
                        <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
                        <path d="M15 18H9"></path>
                        <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                        <circle cx="17" cy="18" r="2"></circle>
                        <circle cx="7" cy="18" r="2"></circle>
                      </svg>
                    </span>
                    <span class="lmg-benefit__txt">Multiple delivery locations? Save them</span>
                  </li>

                  <li class="lmg-benefit">
                    <span class="lmg-benefit__ico" aria-hidden="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart w-full h-full text-[#212529]">
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                      </svg>
                    </span>
                    <span class="lmg-benefit__txt">Save parts to your wishlist for future orders</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        `;

        subtotalMount.innerHTML = '';
        footer.innerHTML = '';

        if (scrollHint) scrollHint.classList.remove('is-visible');
        closeAllAccordions();

        // Hide accordions/subtotal area when empty
        if (bottomScroll) bottomScroll.style.display = 'none';

        if (footer) footer.style.display = 'none';   // ✅ hide footer when empty


        // ✅ EMPTY cart: make the empty scroll cue hide/show on scroll
        if (itemsWrap) {
          itemsWrap.removeEventListener('scroll', updateEmptyScrollCue);
          itemsWrap.addEventListener('scroll', updateEmptyScrollCue);

          // ensure correct state immediately
          setTimeout(updateEmptyScrollCue, 50);
          setTimeout(updateEmptyScrollCue, 250);
        }



        if (itemsWrap) itemsWrap.scrollTop = 0;
        return;
      }

      // Cart not empty: show accordions
      if (bottomScroll) bottomScroll.style.display = '';
      if (footer) footer.style.display = '';  // ✅ show footer again

      itemsEl.innerHTML = cart.items
        .map((item, idx) => {
          const line = idx + 1;
          return `
            <div class="lmg-item" data-line="${line}">
              <div class="lmg-item__imgWrap">
                <img class="lmg-item__img" src="${safeImg(item)}" alt="">
              </div>

              <div class="lmg-item__meta">
                <a class="lmg-item__title" href="${item.url}">${item.product_title}</a>
                <div class="lmg-item__price">${money(item.price)}</div>
              </div>

              <div class="lmg-qty" aria-label="Quantity">
                <button class="lmg-qty__btn" type="button" data-dec aria-label="Decrease quantity">−</button>
                <div class="lmg-qty__num" aria-live="polite">${item.quantity}</div>
                <button class="lmg-qty__btn" type="button" data-inc aria-label="Increase quantity">+</button>
              </div>

              <button class="lmg-remove" type="button" data-remove aria-label="Remove item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2 lucide-trash-2 w-3.5 h-3.5">
                  <path d="M3 6h18"></path>
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                  <line x1="10" x2="10" y1="11" y2="17"></line>
                  <line x1="14" x2="14" y1="11" y2="17"></line>
                </svg>
              </button>
            </div>
          `;
        })
        .join('');

      subtotalMount.innerHTML = `
        <div class="lmg-subtotalCard">
          <div class="lmg-subtotalCard__left">Subtotal</div>
          <div class="lmg-subtotalCard__right">
            <div class="lmg-subtotalCard__amount">${money(cart.total_price)}</div>
            <div class="lmg-subtotalCard__note">Shipping and taxes calculated at checkout</div>
          </div>
        </div>
      `;

      footer.innerHTML = `
        <a href="/cart" class="lmg-viewCart">View Cart</a>
        <a href="/checkout" class="lmg-checkout">Checkout</a>
      `;

      moveSubtotalMobileOnly();
      window.removeEventListener('resize', moveSubtotalMobileOnly);
      window.addEventListener('resize', moveSubtotalMobileOnly);

      attachItemEvents();
      closeAllAccordions();
      updateScrollHint();


      /*
      const notesEl = document.getElementById('lmgNotes');
      if (notesEl && typeof cart.note === 'string') {
        // Don’t overwrite if user already typed this session
        if (!notesEl.dataset.touched) notesEl.value = cart.note;
        notesEl.addEventListener('input', () => notesEl.dataset.touched = '1', { once: true });
      }
      */

      // Notes (cart.note)
      const notesEl = document.getElementById('lmgNotes');
      if (notesEl && typeof cart.note === 'string') {
        if (!notesEl.dataset.touched) notesEl.value = cart.note;
        notesEl.addEventListener('input', () => notesEl.dataset.touched = '1', { once: true });
      }

      // Liftgate attributes (cart.attributes)
      const attrs = cart?.attributes || {};
      const makeEl   = document.getElementById('lmgMake');
      const modelEl  = document.getElementById('lmgModel');
      const serialEl = document.getElementById('lmgSerial');

      if (makeEl && !makeEl.dataset.touched) makeEl.value = attrs.liftgate_make || '';
      if (modelEl && !modelEl.dataset.touched) modelEl.value = attrs.liftgate_model || '';
      if (serialEl && !serialEl.dataset.touched) serialEl.value = attrs.liftgate_serial || '';

      [makeEl, modelEl, serialEl].forEach(el => {
        if (!el) return;
        el.addEventListener('input', () => el.dataset.touched = '1', { once: true });
      });

      

      if (itemsWrap) {
        itemsWrap.removeEventListener('scroll', updateScrollHint);
        itemsWrap.removeEventListener('scroll', updateEmptyScrollCue);

        itemsWrap.addEventListener('scroll', updateScrollHint);
        itemsWrap.addEventListener('scroll', updateEmptyScrollCue);
      }


      setTimeout(updateScrollHint, 250);
      setTimeout(updateScrollHint, 700);
      setTimeout(updateEmptyScrollCue, 250);
    }

    // -------------------------
    // Item events
    // -------------------------
    function attachItemEvents() {
      // Delegate inside drawer to avoid double-binding
      drawer.onclick = async function (e) {
        const inc = e.target.closest('[data-inc]');
        const dec = e.target.closest('[data-dec]');
        const rem = e.target.closest('[data-remove]');


        const viewCart = e.target.closest('.lmg-viewCart');
        const checkout = e.target.closest('.lmg-checkout');

        if (viewCart || checkout) {
          e.preventDefault();

          try {
            //await saveOrderNoteToCart();
            await saveCartMeta();
          } catch (err) {
            console.error('Failed saving cart meta', err);
            //console.error('Failed saving cart note', err);
            // If you want: alert('Could not save order notes. Please try again.');
            // return;
          }

          window.location.href = (checkout ? '/checkout' : '/cart');
          return;
        }

        if (inc || dec || rem) {
          const itemRow = e.target.closest('.lmg-item');
          if (!itemRow) return;

          const line = Number(itemRow.dataset.line);
          if (!line) return;

          if (rem) {
            await changeLine(line, 0);
            return;
          }

          const numEl = itemRow.querySelector('.lmg-qty__num');
          const current = Number(numEl?.textContent || 0);
          const next = current + (inc ? 1 : -1);

          await changeLine(line, Math.max(0, next));
          return;
        }

        const head = e.target.closest('.lmg-acc__head');
        if (head) {
          const acc = head.closest('.lmg-acc');
          if (!acc) return;
          toggleAccordion(acc);
        }
      };
    }

    async function changeLine(line, quantity) {
      if (scrollHint) scrollHint.classList.remove('is-visible');

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line, quantity }),
      });

      await loadCart();
    }

    // -------------------------
    // Accordions (closed by default)
    // -------------------------
    function closeAllAccordions() {
      drawer.querySelectorAll('.lmg-acc').forEach((acc) => {
        acc.classList.remove('is-open');
        const head = acc.querySelector('.lmg-acc__head');
        const body = acc.querySelector('.lmg-acc__body');
        if (head) head.setAttribute('aria-expanded', 'false');
        if (body) body.hidden = true;
      });
    }

    function toggleAccordion(acc) {
      const head = acc.querySelector('.lmg-acc__head');
      const body = acc.querySelector('.lmg-acc__body');
      const isOpen = acc.classList.contains('is-open');

      if (isOpen) {
        acc.classList.remove('is-open');
        if (head) head.setAttribute('aria-expanded', 'false');
        if (body) body.hidden = true;
      } else {
        acc.classList.add('is-open');
        if (head) head.setAttribute('aria-expanded', 'true');
        if (body) body.hidden = false;
      }
    }

    // -------------------------
    // Scroll hint logic (itemsWrap only)
    // -------------------------
    /*
    function updateScrollHint() {
      if (!itemsWrap || !scrollHint) return;

      const canScroll = itemsWrap.scrollHeight > itemsWrap.clientHeight + 4;
      const nearBottom =
        itemsWrap.scrollTop + itemsWrap.clientHeight >= itemsWrap.scrollHeight - 10;

      if (canScroll && !nearBottom) {
        scrollHint.classList.add('is-visible');
      } else {
        scrollHint.classList.remove('is-visible');
      }
    }
    */

    function updateScrollHint() {
      if (!itemsWrap || !scrollHint) return;

      const canScroll = itemsWrap.scrollHeight > itemsWrap.clientHeight + 4;

      const atTop = itemsWrap.scrollTop <= 2; // show only at the very top
      const nearBottom =
        itemsWrap.scrollTop + itemsWrap.clientHeight >= itemsWrap.scrollHeight - 10;

      // ✅ Show only when user hasn't started scrolling yet
      if (canScroll && atTop && !nearBottom) {
        scrollHint.classList.add('is-visible');
      } else {
        scrollHint.classList.remove('is-visible');
      }
    }

    function updateEmptyScrollCue() {
      if (!itemsWrap) return;

      const cueWrap = itemsWrap.querySelector('.lmg-emptyPlus__scrollCueWrap');
      if (!cueWrap) return;

      const canScroll = itemsWrap.scrollHeight > itemsWrap.clientHeight + 4;
      const atTop = itemsWrap.scrollTop <= 10;

      if (canScroll && atTop) {
        cueWrap.style.opacity = '1';
      } else {
        cueWrap.style.opacity = '0';
      }
    }

    // ✅ expose immediately (NOT inside openDrawer)
    window.LMG.openCartDrawer = openDrawer;
    window.LMG.refreshCartDrawer = loadCart;
    window.LMG.renderCartDrawer = (cart) => renderCart(cart);

    window.LMG.flashAddedToCart = flashAddedToCart;

    drawer.dataset.lmgReady = '1';
    return true;
  }

  function boot() {
    if (initLMGDrawer()) return;

    let tries = 0;
    const t = setInterval(() => {
      tries++;
      if (initLMGDrawer() || tries > 60) clearInterval(t);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* =========================
   AJAX ADD TO CART -> OPEN DRAWER
   ========================= */
(function () {
  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  async function waitForLMGReady(maxMs = 5000) {
    const start = Date.now();
    while (!window.LMG?.openCartDrawer || !window.LMG?.renderCartDrawer) {
      if (Date.now() - start > maxMs) return false;
      await sleep(50);
    }
    return true;
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('Failed to fetch cart.js');
    return r.json();
  }

  async function addToCartFromForm(form) {
    const formData = new FormData(form);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData,
      credentials: 'same-origin',
    });

    if (!res.ok) {
      let msg = 'Could not add to cart.';
      try {
        const err = await res.json();
        msg = err?.description || err?.message || msg;
      } catch (e) {}
      alert(msg);
      return;
    }

    await waitForLMGReady();

    // Open drawer + render latest
    window.LMG?.openCartDrawer?.();

    // 🔥 flash header
    if (window.LMG?.flashAddedToCart) {
      window.LMG.flashAddedToCart();
    }

    const cart = await getCart();
    window.LMG?.renderCartDrawer?.(cart);
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    addToCartFromForm(form);
  });
})();
